import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Input, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import ReactToggle from "react-toggle";

function AddEdit_PumpMaster() {
  const API_URL_SAVE = `${API_WEB_URLS.PumpMaster}/0/token`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/PumpEdit/Id`;
  const API_URL = API_WEB_URLS.MASTER + "/0/token/ItemType";
  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      SName: "",
      SPhone: "",
      Username: "",
      Password: "",
      fileUpload: null,
      IsNew: false,
      F_ItemTypeMaster: -1, // Initialize with default value
    },
    FillArray: [],
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [location.state, dispatch]);

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    SName: Yup.string().required("Short Name is required"),
    SPhone: Yup.string()
      .matches(/^\d{10}$/, "Phone must be a 10-digit number")
      .required("Phone is required"),
    Username: Yup.string().required("Username is required"),
    Password: Yup.string().required("Password is required"),
    IsNew: Yup.boolean().required("Active status is required"),
  });

  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const formData = new FormData();
    formData.append("Name", values.Name);
    formData.append("SName", values.SName);
    formData.append("SPhone", values.SPhone);
    formData.append("Username", values.Username);
    formData.append("Password", values.Password);
    formData.append("IsNew", values.IsNew);
    formData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/pumpmaster"
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
          
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Name
                </label>
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="SName" className="form-label">
                  Supervisor Name
                </label>
                <Field className="form-control" type="text" name="SName" />
                <ErrorMessage name="SName" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="SPhone" className="form-label">
                Supervisor Phone
                </label>
                <Field className="form-control" type="text" name="SPhone" />
                <ErrorMessage name="SPhone" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Username" className="form-label">
                  Username
                </label>
                <Field className="form-control" type="text" name="Username" />
                <ErrorMessage name="Username" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Password" className="form-label">
                  Password
                </label>
                <Field className="form-control" type="password" name="Password" />
                <ErrorMessage name="Password" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="2">
                <label htmlFor="IsNew" className="form-label">
                 Is New Supervisor
                </label>
              </Col>
              <Col lg="2">
                <ReactToggle
                  checked={values.IsNew}
                  onChange={() => setFieldValue("IsNew", !values.IsNew)}
                />
                <ErrorMessage name="IsNew" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mt-3">
                <button type="submit" className="btn btn-primary btn-block">
                  Submit
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_PumpMaster;
